// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";

// const useAuthCheck = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     let user = localStorage.getItem("user");
//     console.log(token, "token from useAuthCheck"); // Debug
//     console.log(user, "user from useAuthCheck"); // Debug
    
//     if (!token || !user) {
//       logout();
//       return;
//     }
    

//     user = JSON.parse(user);
//     const lastLogin = user.last_login_at;

//     if (user.role.name !== "admin") {
//       const now = new Date();
//       const loginTime = new Date(lastLogin);
//       const daysSinceLogin = (now - loginTime) / (1000 * 60 * 60 * 24);

//       console.log(daysSinceLogin, "days to logoooooooooooooooooooooooooooooooooo"); // Debug
      

//       // Check if token is expired
//       try {
//         const decodedToken = jwtDecode(token);
//         const tokenExpiry = decodedToken.exp * 1000;

//         console.log(Date.now() >= tokenExpiry || daysSinceLogin >= 30);
        

//         if (Date.now() >= tokenExpiry || daysSinceLogin >= 30) {
//           logout();
//         }
//       } catch (error) {
//         logout();
//       }
//     }
//   }, []);

//   const logout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
//     navigate("/signin"); // Redirect to login page
//   };
// };

// export default useAuthCheck;





import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const parseDateSafely = (dateString) => {
  if (!dateString) return null;

  // ISO 8601
  if (!isNaN(Date.parse(dateString))) return new Date(dateString);

  // MySQL-style "YYYY-MM-DD HH:mm:ss"
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(dateString))
    return new Date(dateString.replace(" ", "T") + "Z");

  // European-style "dd-mm-yyyy"
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
    const [day, month, year] = dateString.split("-");
    return new Date(`${year}-${month}-${day}T00:00:00Z`);
  }

  return null;
};

const useAuthCheck = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    let user = localStorage.getItem("user");

    if (!token || !user) {
      logout();
      return;
    }

    user = JSON.parse(user);
    const loginTime = parseDateSafely(user.last_login_at);
    // console.log("Parsed login time:", loginTime);

    const now = new Date();
    const daysSinceLogin = loginTime
      ? (now - loginTime) / (1000 * 60 * 60 * 24)
      : 0;

    // console.log("daysSinceLogin:", daysSinceLogin);

    try {
      const decodedToken = jwtDecode(token);
      const tokenExpiry = decodedToken.exp * 1000;

      if (Date.now() >= tokenExpiry || daysSinceLogin >= 30 && user.role.name !== "admin") {
        logout();
      }
    } catch (error) {
      logout();
    }
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/signin");
  };
};

export default useAuthCheck;
